import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export enum IndustryIdentificationValues {
  OFFICE = 'office',
  RETAIL_OR_FOOD = 'retail_or_food_service',
  FACTORY = 'factory_construction_or_field',
  OTHER = 'other',
}

const IndustryIdentification = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="industryIdentification"
      id="industryIdentification"
      label="How would you describe your business setting?"
    >
      <Grid rowGap={3} columnGap={4} maxWidth={632} maxWidthMd="100%">
        <SelectableCard
          type="radio"
          aria-label="We work in an office or remotely"
          value={IndustryIdentificationValues.OFFICE}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We work in an office or remotely
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="We work in retail or food service"
          value={IndustryIdentificationValues.RETAIL_OR_FOOD}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We work in retail or food service
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="We work in a factory, construction, or in the field"
          value={IndustryIdentificationValues.FACTORY}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              We work in a factory, construction, or in the field
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard type="radio" aria-label="Other" value={IndustryIdentificationValues.OTHER}>
          <CardHeader>
            <Heading className="answer" level={3}>
              Other
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default IndustryIdentification;
